<template>
  <div class="campusrosterManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-admissionCue">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <span class="c-normal">校内名单跟进</span>
            </div>
          </div>
          <div class="admissionCue-container">
            <div class="content content-special">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == current }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <!--<div class="c-n--head_rt">
                  <el-button type="warning" @click="importAdmission()">{{
                    $t("Admissioncue.ab")
                  }}</el-button>
                  <el-button type="success" @click="ClickAddAdmission()">{{
                    $t("Admissioncue.ac")
                  }}</el-button>
                  <el-button type="primary" @click="daochu">{{
                    $t("Common.btn_export")
                  }}</el-button>
                   *************暂时隐藏***************** -->
                <!-- <el-button type="warning">招生二维码</el-button>
									<el-button type="primary">批量导入</el-button>
                  <el-button type="danger">导出报表</el-button>
                </div>-->
              </div>
              <div
                v-if="!buttonHide && current == 0"
                class="flex-wrap pl20 pr20"
              >
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Customersmanage.ac")
                  }}</span>
                  <div class="rate-box flex-al">
                    <el-rate
                      v-model="selectForm.intention_level"
                      class="client-level-rate"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      @change="handleSelect"
                    ></el-rate>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.student_tracestatus"
                      placeholder="请选择跟踪状态"
                      @change="handleSelect"
                    >
                      <el-option label="待跟踪" value="0"></el-option>
                      <el-option label="持续跟踪" value="1"></el-option>
                    </el-select>
                  </div>
                </div>
                <!-- <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.coursetype_id"
                      placeholder="请选择跟进班组"
                      @change="handleSelect"
                    >
                      <el-option
                        v-for="item in selectForm.courseTypeList"
                        :key="`${item.coursetype_id}${item.coursetype_cnname}`"
                        :label="item.coursetype_cnname"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div> -->
                <div class="flex-al mb10 mr10" v-if="company_isassist == 1">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.principal_ismajor"
                      placeholder="请选择负责人类型"
                      @change="handleSelect"
                      style="width: 160px"
                    >
                      <el-option label="辅招" value="0"></el-option>
                      <el-option label="主招" value="1"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.principal_marketer_id"
                      placeholder="请选择负责人"
                      @change="handleSelect"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.study_coursetype_id"
                      placeholder="请选择在读班级组"
                      style="width: 160px"
                      @change="getCourseType('zhu'), handleSelect()"
                    >
                      <el-option
                        v-for="item in selectForm.zhuCoursetypeList"
                        :key="`${item.coursetype_id}${item.coursetype_cnname}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.unstudy_coursetype_id"
                      placeholder="请选择非在读班级组"
                      style="width: 175px"
                      @change="getCourseType('fu'), handleSelect()"
                    >
                      <el-option
                        v-for="item in selectForm.fuCoursetypeList"
                        :key="`${item.coursetype_id}${item.coursetype_cnname}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.track_coursetype_id"
                      placeholder="请选择跟进班组"
                      style="width: 175px"
                      @change="handleSelect"
                    >
                      <el-option
                        v-for="item in selectForm.fuCoursetypeList"
                        :key="`${item.coursetype_id}${item.coursetype_cnname}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">分配时间：</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.allotTimeRange"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">最后跟踪时间：</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.trackTimeRange"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      placeholder="请输入学员中/英文名、编号、主要联系人姓名、电话、意向课程信息"
                      class="input-cont"
                      style="width: 450px"
                      v-model="selectForm.keyword"
                      @change="handleSelect"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelect"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                </div>
              </div>
              <div
                v-if="!buttonHide && current == 1"
                class="flex-wrap pl20 pr20"
              >
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Customersmanage.ac")
                  }}</span>
                  <div class="rate-box flex-al">
                    <el-rate
                      v-model="selectForm.intention_level"
                      class="client-level-rate"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      @change="handleSelect"
                    ></el-rate>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">流失时间：</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.changelog_range"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">最后跟踪时间:</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.trackTimeRange"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.student_tracestatus"
                      placeholder="请选择跟踪状态"
                      @change="handleSelect"
                    >
                      <el-option label="待跟踪" value="0"></el-option>
                      <el-option label="持续跟踪" value="1"></el-option>
                      <template v-if="current == 1">
                        <el-option label="已柜询" value="2"></el-option>
                        <el-option label="已试听" value="3"></el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.track_coursetype_id"
                      placeholder="请选择跟进班组"
                      style="width: 175px"
                      @change="handleSelect"
                    >
                      <el-option
                        v-for="item in selectForm.fuCoursetypeList"
                        :key="`${item.coursetype_id}${item.coursetype_cnname}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10" v-if="company_isassist == 1">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.principal_ismajor"
                      placeholder="请选择负责人类型"
                      @change="handleSelect"
                      style="width: 160px"
                    >
                      <el-option label="辅招" value="0"></el-option>
                      <el-option label="主招" value="1"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.principal_marketer_id"
                      placeholder="请选择负责人"
                      @change="handleSelect"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      placeholder="请输入学员中/英文名、编号、主要联系人姓名、电话、意向课程信息"
                      class="input-cont"
                      style="width: 450px"
                      v-model="selectForm.keyword"
                      @change="handleSelect"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelect"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                </div>
              </div>
              <div v-else-if="buttonHide" class="flex-wrap pl20 pr20">
                <div class="flex-al mb10 mr10">
                  <el-button
                    @click="layoutVisible = true"
                    type="warning"
                    size="small"
                    >批量取消跟踪</el-button
                  >
                </div>
              </div>
              <div
                class="tableList"
                ref="auto_height_table"
                style="position: relative"
              >
                <SlotTable
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  :operates="operates"
                  @dropdownClick="dropdownClick"
                  @handleCommand="handleCommand"
                  @handleSelectionChange="handleSelectionChange"
                  @handleColumnChange="handleColumnChange"
                  @toggleEditableColumn="toggleEditableColumn"
                ></SlotTable>
                <div class="personalInfo-tips">
                  <i class="crmIcon-ysbh"></i>
                  <span>{{ $t("Common.personalInfo_tips") }}</span>
                </div>
              </div>

              <el-pagination
                style="margin-top: 20px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>

              <!-- 我要跟进弹窗 中间-->
              <el-dialog
                :title="$t('Admissioncue.au')"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose"
              >
                <div class="capital-box">
                  <div class="delTips tc">{{ allotTips }}</div>
                </div>
                <span v-if="isdistrib" slot="footer" class="dialog-footer">
                  <el-button
                    type="primary"
                    v-if="allot_num != '0'"
                    @click="handclickNow(layoutInformation)"
                    >{{ $t("Admissioncue.av") }}</el-button
                  >
                  <el-button @click="dialogVisible = false">{{
                    $t("Admissioncue.aw")
                  }}</el-button>
                </span>
                <span v-if="!isdistrib" slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogVisible = false">{{
                    $t("Admissioncue.ax")
                  }}</el-button>
                </span>
              </el-dialog>
              <!-- 跟班试听 中间-->
              <auditClass
                :leaningVisible="leaningVisible"
                :auditionGenre="auditionGenre"
                :Auditiontime="Auditiontime"
                @handClickcompare="handClickcompare"
                @handClickcancel="handClickcancel"
                @handleClose="handleCloseLean"
              ></auditClass>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 侧边栏编辑-->
    <SliderBox
      :showSliderBox="showSliderBox"
      @hideSliderBox="hideSliderBox"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBox"
        :Userlist="Userlistedit"
        @hideUserSliderBox="hideSliderBox"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :isEdit="isEdit"
        :FamilyRelation="FamilyRelation"
        :UserInformation="UserInformation"
        :repeatList="repeatList"
        @onSubmit="oneditSubmit"
        @checkIntentionClientData="checkIntentionClientData"
        @deleteFamily="deleteFamily"
        @deleteCourse="deleteCourse"
        @wantToTrack="wantToTrack"
      ></userCreate>
    </SliderBox>

    <!-- 新增招生有效名单 -->
    <SliderBox
      :showSliderBox="showSliderCreateBox"
      @hideSliderBox="hideSliderCreateBox"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderCreateBox"
        :Userlist="Userlistcreate"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :repeatList="repeatList"
        :FamilyRelation="FamilyRelation"
        @onSubmit="onSubmit"
        @wantToTrack="wantToTrack"
        @hideUserSliderBox="hideSliderBox"
        @checkIntentionClientData="checkIntentionClientData"
      ></userCreate>
    </SliderBox>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <schoolSeeing
        :showUserSliderBox="showSliderBoxSee"
        :sId="sId"
        :sType="sType"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :activeName="activeName"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @handleSliderClick="handleSliderClick"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :campusrosterStuData="campusrosterStuData"
        :studentType="current"
        @updateList="getCrmStudyStuTrackList"
      ></schoolSeeing>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Admissioncue.ay')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form label-width="120px" ref="BindstudentFrom" :model="BindstudentFrom">
          <el-form-item
            :label="$t('Admissioncue.az')"
            prop="name"
            :rules="[{ required: true, message: '请选择学员' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Admissioncue.ba')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Admissioncue.bb')"
            prop="relation"
            :rules="[{ required: true, message: '请选择绑定关系' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Admissioncue.bc')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>

    <!-- 取消跟踪 -->
    <el-dialog
      title="取消跟踪"
      :visible.sync="layoutVisible"
      class="tan-binding"
      width="550px"
      :before-close="handleClose"
    >
      <div class="create">
        <p class="pl20 pb20">
          您已选择{{
            chooseStuList.length
          }}名学员，取消跟踪后，学员将转回公有学员列表，确定取消跟踪？
        </p>
        <el-form
          :model="layoutFrom"
          ref="cancelFollowForm"
          label-width="85px"
          style="padding: 0px"
        >
          <el-form-item
            label="取消原因"
            prop="reason"
            :rules="[
              { required: true, message: '请输入取消原因', trigger: 'blur' },
            ]"
          >
            <el-input
              type="textarea"
              style="width: 350px"
              v-model="layoutFrom.reason"
              placeholder="请输入取消原因"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="onlayoutSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <el-button @click="createJG = false">取 消</el-button> -->
        <el-button type="primary" size="small" @click="handleCancel"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 转校 -->
    <el-dialog
      :title="$t('Admissioncue.cc')"
      :visible.sync="crossSchoolVisible"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form label-width="85px" style="padding: 0px">
          <el-form-item :label="$t('Admissioncue.bi')">
            <el-select
              filterable
              class="layout-select"
              v-model="crossSchoolFrom.school"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bj')"
            >
              <el-option
                v-for="item in schoolGoalList"
                :key="item.school_id"
                :label="`${item.school_cnname}(${item.school_branch})`"
                :value="item.school_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Admissioncue.bk')">
            <el-select
              filterable
              class="layout-select"
              @change="changReason"
              v-model="crossSchoolFrom.reson_code"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bl')"
            >
              <el-option
                v-for="item in reasonList"
                :key="item.transfer_code"
                :label="item.transfer_name"
                :value="item.transfer_code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Admissioncue.bm')">
            <el-input
              clearable
              type="textarea"
              class="layout-select"
              style="width: 280px"
              :placeholder="$t('Admissioncue.bn')"
              v-model="crossSchoolFrom.reason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCrossSchoolSubmit()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Admissioncue.dy')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Admissioncue.bo'), $t('Admissioncue.bp')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Admissioncue.ax")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 删除重复名单提示 -->
    <el-dialog
      :title="$t('Admissioncue.au')"
      :visible.sync="delRepeat"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Admissioncue.aq") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delRepeatAction()">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <el-button @click="delRepeat = false">{{
          $t("Customersmanage.bk")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import SliderBox from "@/components/SliderBox";
import userCreate from "@/components/User/create.vue";
import schoolSeeing from "@/components/User/schoolSeeing.vue";
import SlotTable from "@/components/tables/slotTable.vue";
import auditClass from "@/components/Class/Class.vue";
import storeAdmissionCue from "./campusroster";
import storeUser from "@/components/User/User";
export default {
  name: "admissionCue-admissionCue",
  data() {
    return {
      openMenu: ["2"],

      sId: "",
      sType: "",
      campusrosterStuData: null,

      showSliderBox: false,
      showSliderBoxSee: false,
      showSliderCreateBox: false,
      settingVisible: false,
      crossSchoolVisible: false, //转校
      delRepeat: false, //删除重复名单
      fullscreenLoading: true, //全屏loading
      seeSliderTitle: this.$t("Admissioncue.aa"),
      currentPage: 1,
      iscanEdit: true,
      isChageTab: false, //是否点击了切换
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      ClassMessage: {}, //选择的试听班级
      data: [],
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      customerId: "", // 客户id
      dialogVisible: false,
      layoutVisible: false, //分配
      // 客户状态0待跟踪1持续跟踪2已柜询3已试听4已转正-1无意向
      clientOption: [
        {
          value: "",
          label: this.$t("Admissioncue.af"),
        },
        {
          value: "0",
          label: this.$t("Admissioncue.br"),
        },
        {
          value: "1",
          label: this.$t("Admissioncue.bs"),
        },
        {
          value: "2",
          label: this.$t("Admissioncue.bt"),
        },
        {
          value: "3",
          label: this.$t("Admissioncue.bu"),
        },
        {
          value: "4",
          label: this.$t("Admissioncue.bv"),
        },
        {
          value: "-1",
          label: this.$t("Admissioncue.bw"),
        },
      ],
      // 转校
      crossSchoolFrom: {
        school: "",
        reson_code: "",
        reason: "",
      },
      schoolGoalList: [], //目标学校
      reasonList: [], //异动原因
      ClientOneId: "", //暂存转校Id
      // 招生渠道类型
      SchoolsourceOption: [],
      ActivityOption: [],
      ChannelOption: [],
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      SchoolCourseOption: [], //意向课程
      repeatList: [], //重复记录列表
      isrepeat: false,
      isRoot: false,
      //用户基本信息
      UserInformation: [],
      FriendRelation: [], //用户绑定关系
      BindingInfor: [],
      FriendName: [], //用户绑定人员名称
      from_client_id: "",
      layoutChiefPerson: [], //分配负责人
      ClientId: "", //暂存分配Id
      moreClientId: [], //暂存分配Id
      isdistrib: false, //是否点击分配
      isTrack: false, //是否点击跟进
      Personinfor: "", //分配人
      Distribinfor: "", //被分配人
      leaningVisible: false,
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      moreVisible: false,
      current: 0,
      input: "",
      input10: "",
      value11: "",
      select: "",
      visitedJG: false,
      createJG: false,
      visitingJG: false,
      sliderWidth: "900px",
      settingchecked: "",
      activeName: "first",
      radio: "1",
      listshow1: false,
      listshow2: false,
      buttonHide: false,
      // checkList: ["1", "柜询"],
      Userlistcreate: {
        containClass: "slider-admissionCue",
        sliderTitle: this.$t("Admissioncue.ac"),
      },
      Userlistedit: {
        containClass: "slider-admissionCue",
        sliderTitle: this.$t("Admissioncue.bsw"),
      },
      isEdit: true,
      filtersOption: ["在校学员跟进", "流失学员跟进"],
      //数据筛选
      selectForm: {
        intention_level: null,
        copy_intention_level: "",
        student_tracestatus: "",
        principal_ismajor: "",
        principal_marketer_id: "",
        track_coursetype_id: "",
        changelog_range: "",
        changelog_startday: "",
        changelog_endday: "",

        allotTimeRange: "",
        allot_starttime: "",
        allot_endtime: "",
        trackTimeRange: "",
        track_starttime: "",
        track_endtime: "",
        last_tracktime: "",

        zhuCoursetypeList: [],
        study_coursetype_id: "",
        fuCoursetypeList: [],
        unstudy_coursetype_id: "",
        courseTypeList: [],
        coursetype_id: "",

        source: "",
        status: "",
        keyword: "",
        activity: "",
        channel: "",
        lapsed: "",
        range_time: "", //创建时间
        client_status: "", //名单状态 0 待分配 1未跟踪 2已邀约 3已试听 4已跟踪 -1 无意向
        client_track_status: "", //跟踪状态 0-待分配 ,1-待跟踪 2-跟踪中,3已转正 -1无意向
        family_mobile: "",
      },

      chooseStuList: [],

      //多条线索信息
      MultipleClues: [],
      isMultiple: false, //是否批量分配
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      loading: false,
      // 取消跟踪
      layoutFrom: {
        reason: "",
      },
      // 分配用户信息暂存
      layoutInformation: [],
      allotTips: "", //分配返回值
      allot_num: "", //分配返回值
      // 侧边栏 跟进基础信息
      clientLevelNum: [], //意向星级
      followFormid: "",
      CommodeData: [], //获取沟通类型
      FamilyRelation: [], //获取家庭亲属关系
      TraceNoteData: [], //沟通模板
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        mutiSelectDisable: true, //是否disable复选框
        errortip: "",
        isShowPersonInfo: true, //是否显示个人资料保护法标识
      },
      columns: [],
      operates: {
        width: 200,
        label: this.$t("Admissioncue.ca"),
        align: "center",
        fixed: "right",
        dropDown: true, //下拉菜单形式
        list: [
          {
            id: "1",
            label: "跟进",
            name: "fllow",
            show: true,
            floowMe: true,
          },
          {
            id: "2",
            label: "取消跟踪",
            show: true,
            name: "cancelFollow",
            noPermission: true,
          },
          // {
          //   id: "3",
          //   label: "跟进",
          //   show: true,
          //   name: "changeSchool",
          //   floowMe: true,
          // }
        ],
      }, // 列操作按钮
      // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 跟踪记录
      recordData: [],
      currentrecordData: [], //最近跟踪记录
      //柜询记录
      recordcolumnWidth: ["150", "150", "250", "auto"],
      tryRecordlist: [],
      recordlistColumn: [],
      recordoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
      },
      recordOperates: {
        width: 200,
        label: this.$t("Admissioncue.ca"),
        align: "center",
        fixed: "right",
        list: [],
      },
      //试听课程表格开始
      //试听课程表格结束
      classResult: [],
      //selcet 搜索
      value8: "",
      //selcet 搜索
      value9: "",
    };
  },
  components: {
    PageNav,
    SlotTable,
    userCreate,
    schoolSeeing,
    auditClass,
    SliderBox,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    // this.getgetClientData();
    this.getCrmStudyStuTrackList();
    this.getCourseType();

    this.getSourceData();
    this.getMarketer(); // 获取招生的负责人
    this.getIntentCourseData(); // 获取意向课程
    this.getCommodeData(); //获取沟通类型
    this.getTraceNoteData(); //获取沟通模板
    // this.getClientNameData();//绑定学员->获取人员名称
    this.getFamilyRelationData(); // 获取家庭亲属关系
    this.getActivityData(); //获取活动名称
    this.getChannelData(); //获取招生渠道明细
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(390); //设置表格高度
  },
  computed: {
    filteredItems: function () {
      return this.recordData.slice(0, 2);
    },
    company_isassist() {
      return this.$store.state.companyIsassist;
    },
  },
  watch: {
    layoutVisible(n) {
      if (!n) {
        this.$refs["cancelFollowForm"].resetFields();
      }
    },
  },
  methods: {
    getCrmStudentOneApi(sid) {
      storeAdmissionCue
        .getCrmStudentOneApi({
          student_id: sid,
          marketer_id: this.marketer_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.campusrosterStuData = data;
        });
    },
    // 取消跟踪
    handleCancel() {
      // crmCancelStudentTrackAction
      this.$refs["cancelFollowForm"].validate((v) => {
        if (v) {
          let arr = [];
          this.chooseStuList.forEach((e) => {
            arr.push({
              student_id: e.student_id,
            });
          });
          storeAdmissionCue
            .crmCancelStudentTrackAction({
              student_array: JSON.stringify(arr),
              marketer_id: this.marketer_id,
              cancel_reason: this.layoutFrom.reason,
              student_type: this.current,
            })
            .then((res) => {
              const { code, msg } = res.data;
              if (code === 200) {
                this.getCrmStudyStuTrackList();
                this.$message.success(msg);
                this.layoutVisible = false;
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return;
        }
      });
    },
    // 二次招生->获取CRM在籍跟进列表
    getCrmStudyStuTrackList() {
      this.selectForm.changelog_startday = this.selectForm.changelog_range
        ? this.selectForm.changelog_range[0]
        : "";
      this.selectForm.changelog_endday = this.selectForm.changelog_range
        ? this.selectForm.changelog_range[1]
        : "";
      this.selectForm.allot_starttime = this.selectForm.allotTimeRange
        ? this.selectForm.allotTimeRange[0]
        : "";
      this.selectForm.allot_endtime = this.selectForm.allotTimeRange
        ? this.selectForm.allotTimeRange[1]
        : "";
      this.selectForm.track_starttime = this.selectForm.trackTimeRange
        ? this.selectForm.trackTimeRange[0]
        : "";
      this.selectForm.track_endtime = this.selectForm.trackTimeRange
        ? this.selectForm.trackTimeRange[1]
        : "";
      storeAdmissionCue
        .getCrmStudyStuTrackList({
          marketer_id: this.marketer_id,
          student_type: this.current,
          intention_level: this.selectForm.intention_level || null,
          student_tracestatus: this.selectForm.student_tracestatus,
          keyword: this.selectForm.keyword,
          p: this.currentPage,
          num: this.pagesize,
          principal_ismajor: this.selectForm.principal_ismajor,
          principal_marketer_id: this.selectForm.principal_marketer_id,
          track_coursetype_id: this.selectForm.track_coursetype_id,
          unstudy_coursetype_id: this.selectForm.unstudy_coursetype_id,
          study_coursetype_id: this.selectForm.study_coursetype_id,
          changelog_startday: this.selectForm.changelog_startday, // 流失时间
          changelog_endday: this.selectForm.changelog_endday,
          track_starttime: this.selectForm.track_starttime, // 跟踪时间
          track_endtime: this.selectForm.track_endtime,
          allot_starttime: this.selectForm.allot_starttime, // 分配时间
          allot_endtime: this.selectForm.allot_endtime,
          last_tracktime: this.selectForm.last_tracktime,
        })
        .then((res) => {
          const { data } = res.data;
          this.tableData = [];
          this.columns = [];
          this.$nextTick(() => {
            this.dataNumber = parseInt(data.allnum);
            var Columns = data.field;
            this.allColumns = data.field;
            this.$Tool.setStorage(
              `getCrmStudyStuTrackList${this.current}`,
              this.allColumns
            );
            this.showColumn = JSON.parse(
              localStorage.getItem(`showGetCrmStudyStuTrackList${this.current}`)
            );
            var fieldColumns = data.field;
            if (
              JSON.parse(
                localStorage.getItem(
                  `showGetCrmStudyStuTrackList${this.current}`
                )
              )
            ) {
              Columns = this.showColumn;
              fieldColumns = this.showColumn;
            }
            this.columns = this.$Common.handleTable(
              Columns,
              this.columnWidth,
              true,
              0
            );
            this.optionscaozuo.loading = false;
            var arr = [];
            var arr2 = [];
            fieldColumns.forEach((item, index) => {
              arr.push({
                key: index,
                label: item.fieldstring,
                disabled: item.custom === "0",
              });
              if (item.show == "0") {
                arr2.push(index);
              }
            });
            this.data = arr;
            this.oprateColumn = arr2;
            this.tableData = data.list;
          });

          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }

          if (this.sId) {
            this.getCrmStudentOneApi(this.sId)
          }
        });
    },
    getCourseType(type) {
      storeAdmissionCue
        .getCourseType({
          marketer_id: this.marketer_id,
          study_coursetype_id:
            type == "zhu" ? this.selectForm.study_coursetype_id : "",
          unstudy_coursetype_id:
            type == "fu" ? this.selectForm.unstudy_coursetype_id : "",
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          let list = [];
          if (code === 200) {
            list = [...data.list];
          } else {
            list = [];
          }
          if (type == "zhu") {
            this.selectForm.fuCoursetypeList = [...list];
          } else if (type == "fu") {
            this.selectForm.zhuCoursetypeList = [...list];
          } else {
            this.selectForm.zhuCoursetypeList = [...list];
            this.selectForm.fuCoursetypeList = [...list];
            this.selectForm.courseTypeList = [...list];
          }
        });
    },

    // 获取转校学校列表
    getAllSchoolApi() {
      storeAdmissionCue
        .getAllSchoolApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          //
          this.schoolGoalList = res.data.data.list;
        });
    },
    // 获取转校原因
    getTransferCnameApi() {
      storeAdmissionCue
        .getTransferCnameApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          //
          this.reasonList = res.data.data.list;
        });
    },
    transferSchoolAction() {
      storeAdmissionCue
        .transferSchoolAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.ClientOneId,
          re_school_id: this.crossSchoolFrom.school,
          note: this.crossSchoolFrom.reason,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getCrmStudyStuTrackList();
            this.crossSchoolVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //获取招生渠道类型
    getSourceData() {
      storeAdmissionCue
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          //
          this.SchoolsourceOption = res.data.data.list;
          // this.SchoolsourceOption.unshift({
          //   frommedia_id: "",
          //   frommedia_name: "不限"
          // });
        });
    },
    //获取活动名称
    getActivityData() {
      storeAdmissionCue
        .getActivity({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          //
          this.ActivityOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      storeAdmissionCue
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeAdmissionCue
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.chiefPerson = res.data.data.list;
        });
    },
    // 获取副负责人
    getfiterChief() {
      storeAdmissionCue
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          main_marketer_id: this.layoutFrom.marketer,
        })
        .then((res) => {
          this.fu_chiefPerson = res.data.data.list;
        });
    },
    //获取意向课程
    getIntentCourseData() {
      // SchoolClassOption
      storeAdmissionCue
        .getIntentCourse({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.SchoolCourseOption = res.data.data.list;
        });
    },
    // 获取家庭亲属关系
    getFamilyRelationData() {
      storeAdmissionCue
        .getFamilyRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.FamilyRelation = res.data.data.list;
        });
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      storeAdmissionCue
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.UserInformation = res.data.data.list;
        });
    },
    // 获取单个客户的跟踪记录
    getclientOneTrackData(id) {
      storeAdmissionCue
        .getclientOneTrack({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          var arr = [];
          res.data.data.list.forEach((item) => {
            var str;
            if (item.track_followmode == "0") {
              str = this.$t("Admissioncue.cd");
            }
            if (item.track_followmode == "1") {
              str = this.$t("Admissioncue.ce");
            }
            if (item.track_followmode == "2") {
              str = this.$t("Admissioncue.cf");
            }
            if (item.track_followmode == "3") {
              str = this.$t("Admissioncue.cg");
            }
            if (item.track_followmode == "-1") {
              str = this.$t("Admissioncue.ch");
            }
            arr.push(
              Object.assign({}, item, {
                track_followcont: str,
              })
            );
          });
          this.recordData = arr;
          this.currentrecordData = arr.slice(0, 2);
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeAdmissionCue
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          this.FriendRelation = res.data.data.list;
        });
    },
    // 获取单个客户的绑定学员信息
    getBindingClientData(id) {
      // BindingInfor
      storeAdmissionCue
        .getBindingClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.BindingInfor = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeAdmissionCue
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          //
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    // 获取单个客户的柜询记录-
    getclientOneInviteData(id) {
      storeAdmissionCue
        .getclientOneInvite({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryRecordlist = res.data.data.list;
          var Columns = res.data.data.field;
          this.recordlistColumn = this.$Common.handleTable(
            Columns,
            this.ClasscolumnWidth,
            false,
            0
          );
        });
    },
    //获取单个客户的试听记录-
    getclientOneAuditionData(id) {
      storeAdmissionCue
        .getclientOneAudition({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
        })
        .then((res) => {
          this.tryClasslist = res.data.data.list;
          var Columns = res.data.data.field;
          this.ClasslistColumn = this.$Common.handleTable(
            Columns,
            this.recordcolumnWidth,
            false,
            0
          );
        });
    },
    // 获取沟通类型
    getCommodeData() {
      storeAdmissionCue
        .getCommode({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.CommodeData = res.data.data.list;
        });
    },
    // 获取沟通模板
    getTraceNoteData() {
      storeAdmissionCue
        .getTraceNote({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.TraceNoteData = res.data.data.list;
        });
    },
    // 点击功能菜单***8获取每条数据
    dropdownClick(row) {
      this.sId = row.student_id;
      this.currentStu = row;
      this.layoutInformation = row;
      this.ClientId = row.client_id;
      this.ClientOneId = row.client_id;
      this.followFormid = row.client_id; //跟进
      this.from_client_id = row.client_id;
      this.customerId = row.client_id; //存储客户ID
      this.chooseStuList = [row];
    },
    // 点击功能菜单
    handleCommand(command) {
      if (command == "cancelFollow") {
        this.layoutVisible = true;
        this.isMultiple = false;
      } else if (command == "fllow") {
        // 我要跟进
        this.Fllowintention(this.ClientId); //转为我的意向客户
        this.getCrmStudentOneApi(this.currentStu.student_id);
        this.getclientOneData(this.ClientId);
        // this.dialogVisible = true;
        this.isRoot = true;
        this.iscanEdit = false;
        this.activeName = "fourth";
        this.isdistrib = true; //是否点击分配
        this.isTrack = true; //是否点击我要跟进
        this.showSliderBoxSee = true;
      } else if (command == "changeSchool") {
        // 转校
        this.handleCrossSchool();
      } else if (command == "delRepeate") {
        // 删除重复
        this.delRepeat = true;
      }
    },
    // 选择查询
    handleSelect() {
      if (
        this.selectForm.copy_intention_level === this.selectForm.intention_level
      ) {
        this.selectForm.intention_level = null;
        this.selectForm.copy_intention_level = "";
      } else {
        this.selectForm.copy_intention_level = this.selectForm.intention_level;
      }
      this.currentPage = 1;
      this.getCrmStudyStuTrackList();
    },
    // 转校原因
    changReason() {
      let reson_code = this.crossSchoolFrom.reson_code,
        reason = "";
      this.reasonList.forEach((item) => {
        if (item.transfer_code == reson_code) {
          reason = item.transfer_name;
        }
      });
      this.crossSchoolFrom.reason = reason;
    },
    // 转校
    handleCrossSchool() {
      this.getAllSchoolApi();
      this.getTransferCnameApi();
      // 数据初始化
      this.crossSchoolFrom = {
        school: "",
        reson_code: "",
        reason: "",
      };
      this.crossSchoolVisible = true;
    },
    // Crm->删除重复名单
    delRepeatAction() {
      this.$http
        .delRepeatAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.ClientOneId,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          //
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getCrmStudyStuTrackList();
            this.delRepeat = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 转校提交
    onCrossSchoolSubmit() {
      this.transferSchoolAction();
    },
    // 招生有效名单->批量无意向
    handleClickloss() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeAdmissionCue
        .gettoLossClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: arrMultiple,
        })
        .then((res) => {
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getCrmStudyStuTrackList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 招生有效名单->流转为我的意向客户
    handleClickintention() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeAdmissionCue
        .gettoMyClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: arrMultiple,
        })
        .then((res) => {
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getCrmStudyStuTrackList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 跟进转为我的意向客户
    Fllowintention(id) {
      storeAdmissionCue
        .addallotClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: id,
          main_marketer_id: this.marketer_id,
          crm_from: "1", ////我要跟进标识
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.layoutVisible = false;
            this.isdistrib = true;
            this.Personinfor = res.data.data.list.client_cnname;
            this.Distribinfor = res.data.data.list.marketer_name;
            this.allotTips = res.data.data.tip;
            this.allot_num = res.data.data.allot_num;
            this.dialogVisible = true;
            this.getCrmStudyStuTrackList();
          } else {
            this.allotTips = res.data.data.tip;
            this.allot_num = res.data.data.allot_num;
          }
        });
    },
    // 招生有效名单批量分配
    handleClickassign() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      this.ClientId = arrMultiple;
      this.isMultiple = true;
      this.layoutVisible = true;
    },
    // 新增招生有效名单
    addClientData(data) {
      storeAdmissionCue.addClient(data).then((res) => {
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.current = 0;
          this.getCrmStudyStuTrackList();
          this.showSliderCreateBox = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 编辑招生有效名单
    editClientData(data) {
      storeAdmissionCue.editClient(data).then((res) => {
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getCrmStudyStuTrackList();
          this.showSliderBox = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 新增时-检测重名
    checkIntentionClientData(val) {
      var id;
      if (this.isEdit) {
        id = this.customerId;
      } else {
        id = "";
      }
      storeAdmissionCue
        .checkIntentionClient({
          token: this.token,
          marketer_id: this.marketer_id,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: val.client_cnname,
          client_mobile: val.client_mobile,
          client_id: id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.isrepeat = false;
          } else {
            if (res.data.data.list != undefined) {
              this.isrepeat = true;
              this.repeatList = res.data.data.list;
            }
          }
        });
    },
    //编辑时删除家庭信息
    deleteFamily(v) {
      if (v.family_id) {
        storeAdmissionCue
          .delFamilyRelation({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            family_id: v.family_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getCrmStudyStuTrackList();
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //编辑时删除课程信息
    deleteCourse(v) {
      if (v.intention_id) {
        storeAdmissionCue
          .delIntentionSource({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            intention_id: v.intention_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getCrmStudyStuTrackList();
              // this.showSliderBox=false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //分配
    // 招生目标线索->为客户分配负责人
    addallotClient(id, more) {
      var clientId = [];
      if (more == 1) {
        clientId.push(id);
      } else {
        clientId = id;
      }
      storeAdmissionCue
        .addallotClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          client_id: clientId,
          main_marketer_id: this.layoutFrom.marketer,
          fu_marketer_id: this.layoutFrom.fu_marketer,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.layoutVisible = false;
            this.isdistrib = false;
            this.Personinfor = res.data.data.list.client_cnname;
            this.Distribinfor = res.data.data.list.marketer_name;
            this.allotTips = res.data.data.tip;
            this.dialogVisible = true;
            this.getCrmStudyStuTrackList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    //分配提交
    onlayoutSubmit() {
      //

      if (this.isMultiple) {
        this.addallotClient(this.ClientId, 0); //单个分配
      } else {
        this.addallotClient(this.ClientId, 1); //批量分配
      }
    },
    //绑定学员提交
    onBindSubmit() {
      //
      storeAdmissionCue
        .bindingClient({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          //
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getCrmStudyStuTrackList();
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      // this.getclientOneData(this.customerId);
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      storeUser.crmTrackStudentAction(v).then((res) => {
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getCrmStudyStuTrackList();
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 显示 列切换
    toggleEditableColumn() {
      this.settingVisible = !this.settingVisible;
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(
        localStorage.getItem(`getCrmStudyStuTrackList${this.current}`)
      );
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage(
        `showGetCrmStudyStuTrackList${this.current}`,
        this.showColumns
      );
      this.settingVisible = false;
      this.getCrmStudyStuTrackList();
    },
    // 编辑列
    Changeoprate() {},
    // 点击新增招生有效名单
    ClickAddAdmission() {
      this.isrepeat = false;
      this.showSliderCreateBox = true;
    },
    // 导入招生名单
    importAdmission() {
      this.$router.push({ path: "/Admissioncue/importAdmission" });
    },
    hideSliderBox() {
      this.showSliderBox = false;
      this.showSliderCreateBox = false;
    },
    sourceFilter() {},
    hideSliderCreateBox() {
      this.showSliderCreateBox = false;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    //新增招生有效名单提交
    onSubmit(value) {
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        this.addClientData(value);
      } else {
        this.$message({
          message: this.$t("Admissioncue.ck"),
          type: "error",
        });
      }
    },
    //编辑招生有效名单提交
    oneditSubmit(value) {
      value["marketer_id"] = this.marketer_id;
      value["token"] = this.token;
      value["school_id"] = this.school_id;
      value["company_id"] = this.company_id;
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        this.editClientData(value);
      } else {
        this.$message({
          message: this.$t("Admissioncue.ck"),
          type: "error",
        });
      }
    },
    // 我要跟踪
    wantToTrack(v) {
      this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.followFormid = v.client_id; //跟进
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.showSliderCreateBox=false;
      this.showSliderBoxSee = true;
      this.isRoot = true;
      this.iscanEdit = false;
      this.activeName = "fourth";
      this.isdistrib = true; //是否点击分配
      this.isTrack = true; //是否点击我要跟进
    },
    changeSize() {},
    handleSliderClick(v) {
      if (v == "first") {
        this.iscanEdit = true;
        this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    //我要跟进
    handleClick(v) {
      this.Fllowintention(v.client_id); //转为我的意向客户
      this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.followFormid = v.client_id; //跟进
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.dialogVisible = true;
      this.isRoot = true;
      this.iscanEdit = false;
      this.activeName = "fourth";
      this.isdistrib = true; //是否点击分配
      this.isTrack = true; //是否点击我要跟进
      // this.showSliderBoxSee = true;
    },
    //立即跟进
    handclickNow(v) {
      this.sId = v.student_id;
      this.sType = v.student_type;
      this.getCrmStudentOneApi(v.student_id);
      this.showSliderBoxSee = true;
      this.dialogVisible = false;
    },
    handleClose(done) {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pagesize = val;
      if (this.current == 0) {
        this.getCrmStudyStuTrackList();
      } else {
        this.getCrmStudyStuTrackList();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.current == 0) {
        this.getCrmStudyStuTrackList();
      } else {
        this.getCrmStudyStuTrackList();
      }
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
      this.chooseStuList = [...val];
    },
    //更多下拉
    handmoreVisible() {
      if (this.moreVisible == false) {
        this.moreVisible = true;
      } else {
        this.moreVisible = false;
      }
    },
    //分配弹窗
    assignClick(v) {
      this.layoutInformation = v;
      (this.layoutFrom = {
        marketer: "",
        fu_marketer: [],
      }), //初始化
        (this.layoutVisible = true);
      this.isMultiple = false;
      this.ClientId = v.client_id;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean() {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then(() => {
          this.leaningVisible = false;
        })
        .catch(() => {});
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.isTrack = false;
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);

      this.sId = v.student_id;
      this.sType = v.student_type;
      this.getCrmStudentOneApi(v.student_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    //筛选
    handleFilter() {
      this.filterActive = true;
    },
    // tab切换
    addClass: function (index) {
      this.current = index;
      // 筛选数据清空
      this.selectForm.source = "";
      this.selectForm.status = "";
      this.selectForm.keyword = "";
      this.selectForm.activity = "";
      this.selectForm.channel = "";
      this.selectForm.family_mobile = "";
      this.selectForm.intention_level = null;
      this.selectForm.copy_intention_level = "";
      this.selectForm.student_tracestatus = "";
      this.selectForm.principal_ismajor = "";
      this.selectForm.principal_marketer_id = "";
      this.selectForm.track_coursetype_id = "";
      this.selectForm.changelog_range = "";
      this.selectForm.changelog_startday = "";
      this.selectForm.changelog_endday = "";
      this.selectForm.allotTimeRange = "";
      this.selectForm.allot_starttime = "";
      this.selectForm.allot_endtime = "";
      this.selectForm.trackTimeRange = "";
      this.selectForm.track_starttime = "";
      this.selectForm.track_endtime = "";
      this.selectForm.study_coursetype_id = "";
      this.selectForm.unstudy_coursetype_id = "";
      this.selectForm.coursetype_id = "";
      this.selectForm.last_tracktime = "";
      this.currentPage = 1;

      this.getCrmStudyStuTrackList();
      this.changeTableHeight();
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let $source = this.selectForm.source;
      if ($source == this.$t("Admissioncue.am")) {
        $source = "";
      }
      let create_starttime = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      let create_endtime = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      let is_today = this.current == 1 ? "1" : "";
      params_str = `&is_today=${is_today}&client_source=${$source}&client_tracestatus=${this.selectForm.status}&keyword=${this.selectForm.keyword}&activity_id=${this.selectForm.activity}&channel_id=${this.selectForm.channel}&parenter_mobile=${this.selectForm.family_mobile}&lapsed=${this.selectForm.lapsed}&client_status=${this.selectForm.client_status}&client_track_status=${this.selectForm.client_track_status}&create_starttime=${create_starttime}&create_endtime=${create_endtime}`;
      let url = storeAdmissionCue.getClient1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;

      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },

    changeTableHeight() {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top +
            80 -
            this.current * 40
        );
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.changeTableHeight();
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("campusrosterManage.less");

.campusrosterManage {
  height: 100vh;
  font-size: 20px;
}
</style>
